// extracted by mini-css-extract-plugin
export var serviceWorker = "ServiceWorker-module--service-worker--1c1b6";
export var serviceWorkerButton = "ServiceWorker-module--service-worker-button--efaa1";